/* Global imports. */
import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { ImageElement } from "@kontent-ai/gatsby-components";
import {getJacketHeight} from "../../helpers"
import ImageKit from "../ImageKit";

const gatsbySiteVariant = process.env.GATSBY_SITE_VARIANT || "";

interface Props {
  isbn: string;
  kontentImage?: any;
  altImagePath?: string;
  title?: string;
  image?: any;
  size?: string,
  width?: number,
  height?: number
  loading?: string
  classNames?: string
}

const EditionImage = ({ isbn, title = "", image, size="S", width, height, altImagePath, loading="lazy", kontentImage, classNames='w-full drop-shadow-book' }: Props) => {

  let imageKitUrl = `placeholder_portrait_aMjPtD9YZ.jpg`;
  if (gatsbySiteVariant === "hh") {
    imageKitUrl = `placeholder_portrait_harriman_house_rKWEhE4VY.png`;
  }

  const ImageKitImage = (width:number) => ImageKit({ image: `tr:f-auto,di-${imageKitUrl},w-${width}/edition/${isbn}.jpg` })
  const imageSize = size === "L" ? 350 : 146;
  const imageDescription = `Book cover for ${title ? title : isbn}`
  const jacketHeight = width && height ? getJacketHeight(width, height, imageSize) : null
  const gatsbyImage = getImage(image)
  const srcSetLarge = `${ImageKitImage(270)} 270w, ${ImageKitImage(270)} 270w`
  const sizesLarge = "(min-width: 640px) 270px, 270px"
  const srcSetSmall = `${ImageKitImage(146)} 146w, ${ImageKitImage(161)} 161w, ${ImageKitImage(171)} 171w, ${ImageKitImage(200)} 200w, ${ImageKitImage(285)} 285w`
  const sizesSmall = "(max-width: 480px) 200px, (max-width: 600px) 200px, (max-width: 999px) 285px, (max-width: 1600px) 146px,  171px"

  const GatsbyImage = () =>  height ? <GatsbyImage image={gatsbyImage} alt={imageDescription} height={jacketHeight} class="book-preview" /> : <GatsbyImage image={gatsbyImage} alt={imageDescription}  />

  const KontentImage = () => <ImageElement
  layout="constrained"
  width={`270`}
  image={kontentImage}
  backgroundColor="#efefef"
  alt={imageDescription}
  className="w-full drop-shadow-book" 
  />

  const ImagePathSupplied = () => <img src={altImagePath} 
  alt={imageDescription} 
  loading={loading} 
  fetchpriority={`${loading === "eager" ? "high" : "auto" }`} 
  className="w-full drop-shadow-book" 
  width={width} 
  height={height} />
  
  const ImageFromIsbn = () => <img src={`${size === "L" ? ImageKitImage(270) : ImageKitImage(171)}`}
  srcSet={size === "L" ? srcSetLarge : srcSetSmall}
  sizes={size === "L" ? sizesLarge : sizesSmall}
  alt={imageDescription} 
  loading={loading} 
  className={classNames} 
  fetchpriority={`${loading === "eager" ? "high" : "auto" }`} 
  width={width ? width : size === "L" ? 270 : 171}
  height={height ? height : width ? null : size === "L" ? 270 : 171} 
  />

  if(image) {
    return GatsbyImage()
  } else if(kontentImage) {
    return KontentImage()
  }else if (altImagePath) {
    return ImagePathSupplied()
  } else {
    return ImageFromIsbn()
  }
}

export default EditionImage;